import { motion, useReducedMotion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';

interface AuthErrorProps {
  message: string;
}

/** Inline failure message under the auth form; fades and slides in. */
export const AuthError = ({ message }: AuthErrorProps) => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.div
      role="alert"
      initial={
        reduceMotion
          ? { opacity: 0 }
          : { opacity: 0, transform: 'translateY(-4px)' }
      }
      animate={{
        opacity: 1,
        transform: 'translateY(0px)',
        transition: { duration: 0.16, ease: [0.23, 1, 0.32, 1] },
      }}
      className="border-destructive/30 bg-destructive/5 text-destructive flex items-start gap-2 rounded-md border px-3 py-2 text-[13px]"
    >
      <AlertCircleIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{message}</span>
    </motion.div>
  );
};
